import { apiUrl, getData } from './apiUtils';

const baseUrl = apiUrl + "/warehouse/dms_orders/";

export function getOrders() {
  return getData(baseUrl, () => {});
}
